<template>
  <v-card class="px-4 py-4 mt-4 grey lighten-5" v-if="jobModel">
    <v-row dense class="my-3">
      <v-col cols="2">
        <v-text-field
          v-model="jobModel.clientRef" label="Client Ref #" dense hide-details outlined
          background-color="white" />
      </v-col>
      <v-col cols="5" v-if="$store.state.details">
        <v-autocomplete
          :items="$store.state.details.products.items.map((a) => a.title).sort()"
          v-model="jobModel.product" label="Product #1" dense hide-details outlined
          background-color="white"
        />
      </v-col>
      <v-col cols="5" v-if="$store.state.details">
        <v-autocomplete
          :items="$store.state.details.products.items.map((a) => a.title).sort()"
          v-model="jobModel.product2" label="Product #2" dense hide-details outlined
          background-color="white"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="6">
        <v-text-field
          v-model="jobModel.name" label="Customer" dense hide-details outlined
          background-color="white" />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="jobModel.email" label="Email" dense hide-details outlined
          background-color="white" />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="jobModel.phone" label="Phone" dense hide-details outlined
          background-color="white" />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="jobModel.mobile" label="Mobile" dense hide-details outlined
          background-color="white" />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="jobModel.fax" label="Fax" dense hide-details outlined
          background-color="white" />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="jobModel.other" label="Other" dense hide-details outlined
          background-color="white" />
      </v-col>
      <v-col cols="5">
        <v-text-field
          v-model="jobModel.address" label="Address" dense hide-details outlined
          background-color="white" />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="jobModel.townSuburb" label="Town / Suburb" dense hide-details outlined
          background-color="white" />
      </v-col>
      <v-col cols="2">
        <v-autocomplete :items="['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA', 'NZ']"
          v-model="jobModel.state" label="State" dense hide-details outlined
          background-color="white" />
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="jobModel.postcode" label="Postcode" dense hide-details outlined
          background-color="white" />
      </v-col>
    </v-row>
    <v-row class="pt-5" dense>
      <v-col cols="6">
        <v-textarea
          v-model="jobModel.description" label="Fault Information" dense hide-details outlined
          rows="3" background-color="white" />
      </v-col>
      <v-col cols="6" v-if="jobModel.id == undefined">
        <v-textarea
          v-model="jobModel.partsRequired" label="Parts Required" dense hide-details outlined
          rows="3" background-color="white" />
      </v-col>
      <v-col cols="12" v-if="jobModel.id == undefined">
        <v-textarea
          v-model="jobModel.otherNotes" label="Other Notes" dense hide-details outlined
          rows="3" background-color="white" />
      </v-col>
    </v-row>
    <v-row dense class="my-3">
      <v-col cols="2">
        <v-menu :close-on-content-click="false" v-model="datePurchasedMenu">
          <template v-slot:activator="{ on }">
            <v-text-field
              dense
              outlined
              clearable
              hide-details
              persistent-hint
              v-on="on"
              label="Date of Purchase"
              background-color="white"
              :value="dateFormat(jobModel.datePurchased)"
              @click:clear="jobModel.datePurchased = null"
            />
          </template>
          <v-date-picker
            no-title
            hide-details
            v-model="jobModel.datePurchased"
            @input="datePurchasedMenu = false"
          ></v-date-picker>
        </v-menu>
        <!-- <v-text-field :value="dateFormat(jobModel.datePurchased)" label="Date of Purchase"
          persistent-hint dense hide-details outlined background-color="white"
        /> -->
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="jobModel.purchasedFrom" label="Place of Purchase" dense hide-details
          outlined background-color="white" />
      </v-col>
      <v-col cols="2">
        <v-text-field v-model="jobModel.licenseNr" label="Serial Number" dense outlined
        background-color="white" hide-details />
      </v-col>
      <v-col cols="3">
        <v-text-field v-model="jobModel.builderInstall" label="Builder / Install"
          dense outlined
          background-color="white" hide-details />
      </v-col>
      <v-col cols="2">
        <v-text-field v-model="jobModel.contactNr" label="Contact #" dense outlined
        background-color="white" hide-details />
      </v-col>
    </v-row>
    <v-row class="pt-5" v-if="jobModel.id == undefined" dense>
      <v-col cols="12">
        <v-btn @click="saveJob" :loading="saveJobLoading" class="primary">Save</v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import * as mutations from '@/graphql/mutations';
import * as queries from '@/graphql/queries';
import { API, graphqlOperation } from 'aws-amplify';

export default {
  props: ['job'],
  created() {
    this.jobModel = this.job ? this.job : {};
  },
  data() {
    return {
      jobModel: {},
      datePurchasedMenu: false,
      saveJobLoading: false,
    };
  },
  methods: {
    async saveJob() {
      this.saveJobLoading = true;

      const {
        notes,
        parts,
        client,
        supplier,
        partsRequired,
        otherNotes,
        ...jobSubset
      } = this.jobModel;

      const nextJobNrResponse = await API.graphql(graphqlOperation(`
        query NextJobNr {
          nextJobNr
        }
      `)).catch(console.log);

      const response = await API.graphql(graphqlOperation(mutations.createJob, {
        input: {
          jobNr: nextJobNrResponse.data.nextJobNr,
          jobClientId: this.$store.state.details.id,
          status: 'Client Created Jobs',
          priority: 'NORMAL',
          startDate: this.moment().format('YYYY-MM-DD'),
          ...jobSubset,
        },
      })).catch((err) => {
        this.$root.$emit('snackbar-flash', { text: err.errors[0].message, color: 'red' });
      });

      if (partsRequired) {
        API.graphql(graphqlOperation(mutations.createJobNote, {
          input: {
            jobNoteJobId: response.data.createJob.id,
            note: `${partsRequired}`,
            sharedWith: ['clients', 'suppliers'],
          },
        })).catch(console.err);
      }

      if (otherNotes) {
        API.graphql(graphqlOperation(mutations.createJobNote, {
          input: {
            jobNoteJobId: response.data.createJob.id,
            note: `${otherNotes}`,
            sharedWith: ['clients', 'suppliers'],
          },
        })).catch(console.err);
      }

      API.graphql(graphqlOperation(queries.clientEvent, {
        subject: `Job #${response.data.createJob.jobNr} - Job created`,
        message: `Job #${response.data.createJob.jobNr} created by ${response.data.createJob.client.title}.\n\nReference Number: ${response.data.createJob.clientRef}\n\nCustomer address: ${response.data.createJob.address}, ${response.data.createJob.townSuburb}, ${response.data.createJob.state} ${response.data.createJob.postcode}\nCustomer phone number: ${response.data.createJob.phone} ${response.data.createJob.mobile} ${response.data.createJob.other}\nCustomer email: ${response.data.createJob.email}\n\nDescription:\n${response.data.createJob.description}`,
      })).catch((err) => console.log(err));

      this.$root.$emit('snackbar-flash', { text: 'Job created' });
      this.jobModel = {};

      this.$router.push({ name: 'job_details', params: { id: response.data.createJob.id } });

      this.saveJobLoading = false;
    },
  },
};
</script>
